import { defineMessages } from 'react-intl';

export default defineMessages({
  waitlistHeader: {
    id: 'waitlist.Header',
    defaultMessage: `Waitlists You're on`,
    description: 'Main header for waitlist page',
  },
  studentWaitlistHeader: {
    id: 'waitlist.header',
    defaultMessage: `{firstName}'s Waitlists`,
    description: 'student\'s waitlist',
  },
  waitlistSubHeader: {
    id: 'waitlist.Subheader',
    defaultMessage: `All programs whose waitlists you’re on are listed below. Any offers made available will display on the {Overview}.`,
    description: `Subheader for waitlist page`,
  },
  waitlistSubHeaderDream: {
    id: 'waitlist.SubheaderDream',
    defaultMessage: `All programs whose waitlists you’re on are listed below.`,
    description: `Subheader for waitlist page`,
  },
  waitlistSearchParagraph: {
    id: 'waitlist.SearchParagraph',
    defaultMessage: `Visit {searching} to find other programs’ waitlists to join.`,
    description: 'All programs have been saved, messaging to tell them what do do next',
  },
  noJoinedWaitlistSearch: {
    id: 'waitlist.noJoinedWaitlistSearch',
    defaultMessage:
      'You haven’t joined any waitlists. Try {searching} and saving some programs you are ' +
      'interested in. You can add your child to waitlists by clicking on the program name next' +
      ' to the star. Next, click “Join Waitlist” to add your child to the waitlist.',
    description: 'No saved programs head',
  },
  noJoinedWaitlistSearchDream: {
    id: 'waitlist.noJoinedWaitlistSearchDream',
    defaultMessage:
      'You haven’t joined any waitlists. ' +
      'You can add your child to waitlists by clicking on the program name below.',
    description: 'No saved programs head',
  },
  waitlistOfferAcceptance: {
    id: 'waitlist.waitlistOfferAcceptance',
    defaultMessage:
      `Accepting or declining an offer does not impact your position on other waitlist offers 
      in the future. You can only have one accepted offer at a time, which means that accepting 
      a waitlist offer will decline any offer that you previously accepted`,
    description: 'Waitlist offer acceptance',
  },
  waitlistOffersHeader: {
    id: 'waitlist.offersHeader',
    defaultMessage: 'Offers',
    description: 'Header for a list of current school offers',
  },
  waitlistOverview: {
    id: 'waitlist.overview',
    defaultMessage: 'Overview',
    description: 'Overview',
  },
  waitlistPendingOffersHeader: {
    id: 'waitlist.pendingOffers',
    defaultMessage: 'Pending Offers',
    description: 'Header for a list of pending waitlist offers',
  },

  applyMaxProgramsReachedMessage: {
    id: 'apply.MaxProgramsReachedMessage',
    defaultMessage:
      'Your application is full! If you would like to replace one of your current {maxPrograms} choices with this program, select the program you would like to remove from your application.',
    description: 'Student has reached the max number of programs for an application',
  },
  noSavedProgramsSearch: {
    id: 'apply.noSavedProgramsSearch',
    defaultMessage: `You haven’t added any programs to your favorites! Search for options and click the star to add them to your favorites. Then return here and add them to your application. If you know exactly which programs you’d like to apply to, you can {search} for them directly in the application to your left.`,
    description: 'No favorite programs head',
  },
  noSavedProgramsApplication: {
    id: 'apply.noSavedProgramsApplication',
    defaultMessage: `Or if you know exactly which programs you want to apply to, you can search for them directly from the application list.`,
    description: 'No favorite programs',
  },
  allProgramsSavedParagraphOne: {
    id: 'apply.allProgramsSavedParagraphOne',
    defaultMessage: `You’ve added all your favorite programs to your application! If you’re looking for more programs to apply to, try {searching} and adding some more to your favorites.`,
    description: 'All favorite programs have been added, messaging to tell them what to do next',
  },
  addSavedProgram: {
    id: 'apply.addSavedProgram',
    defaultMessage: `Add program: {savedProgram}, school: {programSchool}`,
    description: 'Add saved program to your application',
  },
  cannotApplySubmissionsClosed: {
    id: 'apply.cannotApplySubmissionsClosed',
    defaultMessage: 'Submissions are closed. Programs cannot be added to your application at this time.',
    description: 'Message when submissions are not open',
  },
  applicationExplanatoryText: {
    id: 'applicationdragcontainer.ExplanatoryText',
    defaultMessage:
      'Drag and drop programs to list them in your order of preference. Once you’re happy with your list, click the "Next" button at the bottom to get ready to submit it.',
    description: 'Explanatory text for applications drag and drop, ordering',
  },
  applicationExplanatoryTextLGA: {
    id: 'applicationdragcontainer.ExplanatoryTextLGA',
    defaultMessage:
      'Drag and drop programs to the list. Once you’re happy with your list, click the "Next" button at the bottom to get ready to submit it.',
    description: 'Explanatory text for applications drag and drop',
  },
  applyApplicationButton: {
    id: 'apply.ApplicationButton',
    defaultMessage: 'Your Application',
    description: 'Your application button text',
  },
  waitlistNoWaitlistOffers: {
    id: 'waitlist.NoWaitlistOffers',
    defaultMessage: "You don't have any offers.",
    description: 'No offers message',
  },
  waitlistNoCurrentOffers: {
    id: 'waitlist.NoCurrentOffers',
    defaultMessage: "Looks like you have not accepted or declined any offers.",
    description: 'No current offers',
  },
  waitlistSupplimentalLinkText: {
    id: 'waitlist.SupplimentalLinkText',
    defaultMessage: "View your supplemental form responses",
    description: 'Click here to view and modify supplemental form responses',
  },
  waitlistAlertModalAcceptTitleText: {
    id: 'waitlist.AlertModalAcceptTitleText',
    defaultMessage: "Accepting this offer will decline your previous offer",
    description: 'Title for alert box that appears while accepting the offer',
  },
  waitlistAlertModalDeclineTitleText: {
    id: 'waitlist.AlertModalDeclineTitleText',
    defaultMessage: "Decline offer",
    description: 'Title for alert box that appears while declining the offer',
  },
  waitlistAlertModalRemoveTitleText: {
    id: 'waitlist.AlertModalRemoveTitleText',
    defaultMessage: "Remove from Waitlist",
    description: 'Title for alert box that appears while removing from waitlist',
  },
  waitlistAlertModalAcceptSubTitleText: {
    id: 'waitlist.AlertModalAcceptSubTitleText',
    defaultMessage: "Accepting this offer will decline your child's offer(s) from:",
    description: 'Sub Title for alert box that appears while accepting the offer',
  },
  waitlistAlertModalDeclineSubTitleText: {
    id: 'waitlist.AlertModalDeclineSubTitleText',
    defaultMessage: "This action will decline your offer to",
    description: 'Sub Title for alert box that appears while declining the offer',
  },
  waitlistAlertModalRemoveSubTitleText: {
    id: 'waitlist.AlertModalRemoveSubTitleText',
    defaultMessage: "Taking this action will remove your child from the Waitlist for",
    description: 'Sub Title for alert box that appears while removing from waitlist',
  },
  waitlistAlertModalAcceptButtonText: {
    id: 'waitlist.AlertModalAcceptButtonText',
    defaultMessage: "Yes, accept this new offer",
    description: 'Alert box accept button text',
  },
  waitlistAlertModal2KAcceptTitleText: {
    id: 'waitlist.AlertModal2KAcceptTitleText',
    defaultMessage: 'Important next steps',
    description: 'Title for 2K accept warning modal',
  },
  waitlistAlertModal2KAcceptMessageText: {
    id: 'waitlist.AlertModal2KAcceptMessageText',
    defaultMessage: 'After accepting this offer, you must still apply for Fall 2027 admissions when the application becomes available.',
    description: 'Warning message shown to 2K applicants born in 2025 when accepting an offer',
  },
  waitlistAlertModal2KAcceptButtonText: {
    id: 'waitlist.AlertModal2KAcceptButtonText',
    defaultMessage: 'Continue',
    description: 'Accept button text for 2K DOB warning modal',
  },
  waitlistAlertModalDeclineButtonText: {
    id: 'waitlist.AlertModalDeclineButtonText',
    defaultMessage: "Yes, decline this offer",
    description: 'Alert box decline button text',
  },
  waitlistAlertModalRemoveButtonText: {
    id: 'waitlist.AlertModalRemoveButtonText',
    defaultMessage: "Yes, remove my child from this waitlist",
    description: 'Alert box remove button text',
  },
  waitlistAlertModalCancelButtonText: {
    id: 'waitlist.AlertModalCancelButtonText',
    defaultMessage: "Cancel",
    description: 'Alert box cancel button text',
  },
  waitlistAlertModalDeclineSubNoteText: {
    id: 'waitlist.AlertModalDeclineSubNoteText',
    defaultMessage: "You cannot accept this offer again after declining.",
    description: 'Decline alert box sub note added to the end of message',
  },
});
